import { schema } from 'normalizr';

import { processGroupMemberCount } from '../strategies/groupMemberCount';

export const groupMemberCountSchema: schema.Entity = new schema.Entity(
  'groupMemberCounts',
  {},
  { processStrategy: processGroupMemberCount }
);

export type GroupMemberCountEdgesSchema = typeof groupMemberCountEdgesSchema;
export const groupMemberCountEdgesSchema: schema.Object[] = [new schema.Object({ node: groupMemberCountSchema })];
